module.exports = __webpack_public_path__ + "static/media/incorrect.07cb023a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/stores/audio/incorrect.mp3
// module id = 630
// module chunks = 0